<template>
	<div>
		<div @click="choose(item.house_id)" v-for="(item,index) in list" :key="index" class="width-100 b-b p-b-10 p-t-10">
			<div class="d-flex-row">
				<div class="">
					<img :src="item.image" class="w-140 h-130 br-10" />
				</div>
				<div class="w-60p p-l-10">
					<div class="f-20 c-00 m-t-20">{{item.hr_name}}</div>
					<div class="f-12 c-66 d-flex-row m-t-15 overtext">
						<span>{{item.house_categorylist}}</span>
						<span class="m-l-10 m-r-10">|</span>
						<span class="">{{item.measure_area}}</span>
					</div>
					<div class="f-14 c-66 d-flex-between m-t-20 w-97p">
						<div class="c-EC4738 font-weight-bold">￥{{item.now_price}}/月</div>
						<div class="line">￥{{item.rent}}/月</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			list: [Object, Array]
		},
		methods: {
			choose(index) {
				this.$emit('choose', index)
			}
		}
	}
</script>

<style>
</style>
